import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import { Link } from "react-router";
import Spinner from "../components/spinner.react";
import InputWithError from "../components/inputWithError.react";

export default class SetPassword extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    msg: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions, users: { forms } } = this.props;
    actions.clearForm("users", "setPassword");
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {
      actions,
      users: { forms },
      notificationSystem,
      params
    } = this.props;
    actions
      .setPassword(forms.setPassword.fields, params.token)
      .then(({ error, payload }) => {
        if (error) {
          focusInvalidField(payload, this, "setPassword");
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  redirectToLogin = () => {
    const { history } = this.props;
    history.pushState(null, "/");
  };

  render() {
    const { actions, users: { forms }, msg: { users: msg } } = this.props;

    const setPasswordFormProps = {
      feature: "users",
      actions: actions,
      form: forms.setPassword,
      formName: "setPassword",
      msg: msg.forms.setPassword,
      validateFormField: actions.validateFormFieldUsers
    };

    return (
      <div className="auth-page row center-xs middle-xs">
        <div className="col-xs-12 col-lg-3 auth-box">
          <h1>Fluct</h1>
          {!forms.setPassword.sent && <h2>Ustal nowe hasło</h2>}
          {forms.setPassword.sent && (
            <div>
              <h2>Dziękujemy!</h2>
              <h4>Twoje hasło zostało zmienione</h4>
              <input
                className="info"
                onClick={this.redirectToLogin}
                defaultValue="Powrót do logowania"
                type="button"
              />
            </div>
          )}
          {!forms.setPassword.sent && (
            <form onSubmit={this.onFormSubmit} name="setPassword" noValidate>
              <div className="row center-xs top-xs">
                <div className="col-xs-12">
                  <div className="row start-xs middle-xs input-wrapper">
                    <div className="col-xs-12">
                      <div className="box center-with-input">
                        <label htmlFor="password" className="label">
                          Hasło
                        </label>
                      </div>
                    </div>
                    <div className="col-xs-12">
                      <div className="box">
                        <InputWithError
                          field={"password"}
                          type="password"
                          {...setPasswordFormProps}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="row start-xs middle-xs input-wrapper">
                      <div className="col-xs-12">
                        <label htmlFor="passwordConfirm" className="label">
                          Powtórz hasło
                        </label>
                      </div>
                      <div className="col-xs-12">
                        <InputWithError
                          field={"passwordConfirm"}
                          type="password"
                          {...setPasswordFormProps}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row center-xs top-xs">
                <div className="col-xs-12">
                  <button
                    className="success"
                    disabled={
                      forms.setPassword.disabled ||
                      !isFormValid(forms.setPassword)
                    }
                  >
                    {forms.setPassword.disabled && <Spinner />}
                    Zmień hasło
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/auth/SetPassword.react.js